import { DEBUG_MODE } from './config'

export const DEBUG_TELEMETRY: boolean = false

export interface UserLiveState {
  web2UserId: string
  status: 'Online' | 'Playing' | 'Offline'
  currentTrack: string | null
}

export const mergeUserTelemetry = (
  currentUsers: any[],
  liveStatuses: any,
): any[] => {
  if (!currentUsers || currentUsers.length === 0 || !liveStatuses) {
    return currentUsers
  }
  let ret: any = currentUsers
  try {
    let hasChanged = false
    const merged = currentUsers.map((user) => {
      const liveState = liveStatuses[user.web2UserId]
      const targetStatus = liveState ? liveState.status : 'Offline'
      const targetTrack = liveState ? liveState.currentTrack : null
      if (user.status !== targetStatus || user.currentTrack !== targetTrack) {
        hasChanged = true
        return {
          ...user,
          status: targetStatus,
          currentTrack: targetTrack,
        }
      }
      return user
    })
    ret = hasChanged ? merged : currentUsers
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}
